import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: localStorage.getItem('userInfo') &&
              localStorage.getItem('userInfo') !== '' ? JSON.parse(localStorage.getItem('userInfo')) : null
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload
      localStorage.setItem('userInfo', JSON.stringify(action.payload))
    },
  }
})

export const {
  setUserInfo
} = userSlice.actions

export default userSlice.reducer